import request from '@/libs/request'

/**
 * 获取 appid
 */

export function getAppid() {
  return request({
    url: 'site/get-app-id',
    methods: 'GET'
  })
}

/**
 * 获取 openid && token
 * 验证是否已绑定微信
 * @param {String} rq 请求参数
 */

export function getOpenid(code) {
  return request({
    url: 'site/login-status',
    method: 'get',
    params: {
      code: code
    }
  })
}

/**
 * 获取 用户信息
 */

export function getUserInfo() {
  return request({
    url: 'site/user-info',
    methods: 'GET'
  })
}

/**
 * 更改订单支付成功通知
 */

export function setpayNotify(pay_success_notify) {
  return request({
    url: 'site/pay-notify',
    methods: 'GET',
    params: {
      pay_success_notify
    }
  })
}

/**
 * isv信息查询
 * @param {Object} params isv信息获取
 */
export function IsvConfig(params) {
  return request({
    url: '/eachend/eachend-public/get-config-info',
    baseURL: process.env.VUE_APP_ISV_API,
    method: 'GET',
    params
  })
}
